export default __webpack_public_path__ + "b5bfedb008252d4dcdb90b3c0b286a5f.gif";